/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet, View } from 'react-native';

function SociollaList({ children, index, style, ...otherProps }) {
  return (
    <View style={style}>
      {index > 0 && (
        // <Divider orientation="horizontal" />
        <View style={styles.border} />
      )}
      <View style={styles.list} {...otherProps}>
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  // eslint-disable-next-line react-native/no-color-literals
  border: {
    height: 1,
    backgroundColor: '#EDEDEE',
    alignSelf: 'stretch',
    marginHorizontal: -16,
  },
  list: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
});

export default SociollaList;
